export default class Poi {
    constructor(titles, tagLines, contents, times, specialties, categories, images, type, featuredImage, files, publishDate, contact,address,latitude,longitude,website,rating,minPrice,maxPrice) {
        this.titles = titles;
        this.tagLines = tagLines;
        this.contents = contents;
        this.times = times;
        this.specialties = specialties;
        
        this.categories = categories;
        this.images = images;
        
        this.type = type;
        this.featuredImage = featuredImage;
        this.files = files;
        this.publishDate = publishDate;
        this.contact = contact;
        this.address = address;
        this.latitude = latitude;
        this.longitude = longitude;
        this.website = website;
        this.rating = rating;
        this.minPrice = minPrice;
        this.maxPrice = maxPrice;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.tagLines)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }
        if(this.type == "See" || this.type == "Eat") for (const [key, value] of Object.entries(this.times)) { if(!value) { result = false; break; }; }
        if(this.type == "Eat") for (const [key, value] of Object.entries(this.specialties)) { if(!value) { result = false; break; }; }
        
        if(result) result = this.categories && this.categories.length && this.images && this.images.length && this.featuredImage && this.contact && this.address && this.latitude && this.longitude && this.type;
        
        if(result)
        {
            if(this.type == "Eat" || this.type == "stay") result = this.website && this.minPrice && this.maxPrice
            else if(this.type == "Eat") result = this.specialties;
            else if(this.type == "Stay") result = this.rating;
        }
        return result;
    }
}